import React from "react";
import PhotoImage from "./PhotoImage";
import FondoEstudio from "./FondoEstudio";
import WhatsAppCta from "./WhatsAppCta";
import { ESTUDIO } from "../../data/estudio";
import { FOTO_HERO, MOMENTOS } from "../../data/momentos";
import { PRECIOS, formatCLP } from "../../data/precios";
import { segmentoPorId } from "../../data/segmentos";

/**
 * El banner de siempre: eventos.
 *
 * Vivía dentro de HomePage. Salió a su propio archivo cuando la campaña de
 * temporada pasó a compartir carrusel con él: dos diapositivas que se alternan
 * tienen que ser dos piezas comparables, no una incrustada en la página y la
 * otra en un componente.
 *
 * LA FOTO MANDA. En escritorio ocupa el lado derecho y se funde hacia el
 * titular, que queda sobre fondo oscuro sin tapar la imagen. En móvil la foto
 * va entera arriba y el texto debajo: un titular encima de la foto en 375 px
 * tapa justo lo que se vino a mostrar.
 *
 * `pb-20` abajo y no `pb-14`: los controles del carrusel se superponen en el
 * borde inferior y sin ese aire pisarían los botones.
 */
const eventos = segmentoPorId("eventos");

const FotoHeroEventos = () => (
  <section id="inicio" className="group relative overflow-hidden bg-navy-950 text-white">
    <div className="relative lg:absolute lg:inset-y-0 lg:left-[30%] lg:right-0">
      {FOTO_HERO ? (
        <PhotoImage
          foto={FOTO_HERO}
          bn
          sizes="(min-width: 1024px) 70vw, 100vw"
          priority
          className="aspect-[5/4] h-full w-full object-cover object-center lg:aspect-auto"
        />
      ) : (
        <FondoEstudio variante="softbox" priority />
      )}
      <div
        className="absolute -inset-x-px inset-y-0 bg-gradient-to-t from-navy-950 via-navy-950/10 to-navy-950/50 lg:bg-[linear-gradient(90deg,#0B0A09_0%,rgba(11,10,9,0.94)_10%,rgba(11,10,9,0.55)_28%,rgba(11,10,9,0.12)_50%,rgba(11,10,9,0)_70%)]"
        aria-hidden="true"
      />
    </div>

    <div className="container-omega relative z-10 pb-20 pt-6 lg:flex lg:min-h-[88vh] lg:items-end lg:pb-28 lg:pt-40">
      <div className="max-w-xl">
        <p className="hero-enter text-sand-300">Fotógrafo de bodas y eventos · {ESTUDIO.ciudad}</p>
        <h1 className="hero-enter mt-4 font-display text-display-md font-bold text-white">
          Guardamos tus emociones en imágenes maravillosas.
        </h1>
        <ul className="hero-enter mt-6 flex flex-wrap gap-2" style={{ animationDelay: "80ms" }}>
          {MOMENTOS.map((momento) => (
            <li
              key={momento.id}
              className="rounded-full border border-white/25 bg-navy-950/40 px-3.5 py-1.5 text-sm text-white backdrop-blur-sm"
            >
              {momento.titulo}
            </li>
          ))}
        </ul>
        <p
          className="hero-enter mt-7 font-display text-4xl font-extrabold tabular-nums text-white sm:text-5xl"
          style={{ animationDelay: "120ms" }}
        >
          <span className="mr-3 font-display text-xl font-bold text-sand-300">Desde</span>
          {formatCLP(PRECIOS.horaYMedia)}
        </p>
        <div
          className="hero-enter mt-8 flex flex-col gap-3 sm:flex-row"
          style={{ animationDelay: "180ms" }}
        >
          <WhatsAppCta message={eventos.whatsapp} location="home_hero" className="w-full sm:w-auto">
            Reservar mi fecha
          </WhatsAppCta>
          <a href="#momentos" className="btn-on-dark-outline w-full sm:w-auto">
            Ver los eventos
          </a>
        </div>
      </div>
    </div>
  </section>
);

export default FotoHeroEventos;
